import React from "react";
import { v4 as uuidv4 } from "uuid";

import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";

import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import userByIdStore from "../../flux/stores/user/ByIdStore";

import * as CONSTANTS from "../../utilities/Constants";
import UserViewData, {
  defaultUserData,
  IUserViewData
} from "../../models/user/UserViewData";

import { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import { UserFormData } from "../../models/user/UserFormData";
import { Translation } from "react-i18next";
import History from "../../utilities/History";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  userData: UserViewData;
}

interface ILandingProperties {
  userData: UserViewData;
  activeId: string;
  disableDeleteUser: boolean;
}

export default class Landing extends React.Component<ILandingProperties, ILandingState> {
  private _mount: boolean = false;

  constructor(props: any) {
    super(props);
    this._mount = true;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
  }

  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public render() {
    
    return ( 
    <Translation>
      {(t) => (
      <div className="page-layout">
        {renderBreadcrumb(
          [
            { text: t("Home"), link: "/samplenew", bolder: false },
            { text: t(CONSTANTS.MENU_ACCOUNT_MANAGEMENT), link: null, bolder: false },
            { text: t(CONSTANTS.MODULE_USERS), link: null, bolder: true }
          ], "pl-3 pb-3")
        }
        <NameHeader data={this.props.userData.firstName + " " + this.props.userData.lastName}
         disableEditOrDelete={true}  disableDelete={this.props.disableDeleteUser} authKey={CONSTANTS.AUTHKEY_USERS} />
        <div className="summary-layout">
        <Summary>
          <div className="page-scroll">
            <div className="row mt-3">
              <div className="col-md-4 breakword">
                <span className="summary-label mr-2">
                  {t(CONSTANTS.LABEL_FIRST_NAME)}:{" "}
                  </span>
                <span className="summary-value">
                  {this.props.userData.firstName}
                </span>
              </div>
              <div className="col-md-4 breakword">
                <span className="summary-label mr-2">
                 {t(CONSTANTS.LABEL_LAST_NAME)}:{" "}
                </span>
                <span className="summary-value">
                  {this.props.userData.lastName}
                </span>
              </div>

              <div className="col-md-4 breakword">
                <span className="summary-label mr-2">
                 {t(CONSTANTS.LABEL_USERNAME)}:{" "}
                </span>
                <span className="summary-value">
                  {this.props.userData.username}
                </span> 
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 breakword">
                <span className="summary-label mr-2">
                {t(CONSTANTS.LABEL_EMAIL)}:{" "}
                </span>
                <span className="summary-value">
                  {this.props.userData.email}
                </span>
              </div>
              <div className="col-md-4">
                <span className="summary-label mr-2">
                {t(CONSTANTS.LABEL_ROLE)}:{" "}
                </span>
                <span className="summary-value">
                  {this.props.userData.role?.name}
                </span> 
              </div>
          </div>
         </div> 
        </Summary>
        </div>
      </div>
       )}
       </Translation>
    );
  }
}
